module.exports = __webpack_public_path__ + "static/Levin.5729877f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Levin.jpg
// module id = 1307
// module chunks = 137408898365125